webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _main = __webpack_require__(4);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _p = __webpack_require__(0);

var _p2 = _interopRequireDefault(_p);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var centerX = void 0,
    centerY = void 0;
var pos = [];
var noiseTime = 0;
var noiseTime_2 = 0;
// let startTop = 0;
// let startLeft = 0;
var size = 8;

window.setup = function () {
    createCanvas(window.innerWidth, window.innerHeight);
    centerX = width / 2;
    centerY = height / 2;
    for (var i = 0; i < size; i++) {
        pos.push(createVector(width / (size - 1) * i, 0));
    }
    blendMode(ADD);
    colorMode(HSB, 360, 100, 100, 1);
    background(0);
    // startTop = -200;
    // startLeft = -width;
};
window.draw = function () {
    background(0);
    // background(255);
    // startTop = startTop >= height ? -200: startTop+1;
    // startLeft = startLeft >= width ? -width : startLeft+1;
    var timeJump = map(mouseY, 0, height, 0.0005, 0.01);
    timeJump = 0.001;
    noiseTime += timeJump;
    noiseTime_2 += 0.001;

    var newColor = map(cos(noiseTime), -1, 1, 0, 360);
    var range = constrain(noiseTime_2, 1, 4);
    var centerOffset = map(range, 1, 4, 0, height / 2 - height / range / 2);

    push();
    translate(0, centerOffset);
    noFill();
    stroke(newColor, 100, map(mouseX, 0, width, 5, 100), 0.03);
    beginShape();
    curveVertex(0, noise(noiseTime_2) * height / range);
    for (var i = 0; i < pos.length; i++) {
        var x = pos[i].x;
        var y = noise(noiseTime, i) * height / range;
        curveVertex(x, y);
    }
    curveVertex(width, noise(noiseTime_2) * height / range);
    endShape();
    pop();
};

window.windowResized = function () {
    resizeCanvas(window.innerWidth, window.innerHeight);
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _css = __webpack_require__(1);

var _css2 = _interopRequireDefault(_css);

var _js = __webpack_require__(2);

var _js2 = _interopRequireDefault(_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[3]);


// WEBPACK FOOTER //
// app.js